import { axiosNewInstance } from "../config/Api";

// };
const token = localStorage.getItem("authToken");
// const token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC8yMDIuMTI2LjEyNC4xOTRcL2xpY1wvbGljYWRtaW5cL1wvYXBpLWFwcFwvbWF0Y2gtb3RwIiwiaWF0IjoxNzQwNDcxNTAwLCJleHAiOjE3NDA0NzUxMDAsIm5iZiI6MTc0MDQ3MTUwMCwianRpIjoiQ3pUbWM2ZTZmWG9ZOFdtUCIsInN1YiI6MTAyNywicHJ2IjoiNzRhYzgxMDNmMGU2ZDFkNzQ3ODc2OTM2OWIwMjFhMWY5ZjYwNWQxNiIsInR5cGUiOiJjdXN0b21lciJ9.V1HD_ZkKvahZ80TU40MliT8iFGEW1FS7_tAgq8QQPUM";
const configToken = {
  headers: {
    Authorization: `Bearer ${token}`,
  },
};
export default configToken;

const API_BASE_PATH = "/api-app";
export const fetchData = async (endpoint, payload = {}) => {
  const API_URL = `${API_BASE_PATH}/${endpoint}`;
  // Get token dynamically for each request
  const currentToken = localStorage.getItem("authToken");

  // if (!currentToken) {
  //   return {
  //     success: false,
  //     error: "Authentication token not found. Please login again."
  //   };
  // }

  try {
    const response = await axiosNewInstance.post(API_URL, payload, {
      headers: {
        Authorization: `Bearer ${currentToken}`,
        "Content-Type": "application/json",
      },
    });
    return { success: true, data: response.data };
  } catch (error) {
    // Handle 401 unauthorized errors
    // if (error.response?.status === 401) {
    //   localStorage.removeItem("authToken");
    //   window.location.href = "/login"; // Redirect to login page
    // }
    return { success: false, error: error.response?.data || error.message };
  }
};
export const getFetchData = async (endpoint, payload = {}) => {
  const API_URL = `${API_BASE_PATH}/${endpoint}`;
  // Get token dynamically for each request
  const currentToken = localStorage.getItem("authToken");

  try {
    const response = await axiosNewInstance.get(API_URL, {
      headers: {
        Authorization: `Bearer ${currentToken}`,
        "Content-Type": "application/json",
      },
    });
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: error.response?.data || error.message };
  }
};
export const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return true;
    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    const { exp } = JSON.parse(jsonPayload);
    if (!exp) return false;
    return Date.now() >= exp * 1000;
  } catch (e) {
    return true;
  }
};

export const clearAuthSession = () => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("user_name");
  localStorage.removeItem("activeItem");
};

export const capitalize = (text) => {
  return text ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() : "";
};
export const policyNameId = {
  801: "Jibon Rakkhak",
  802: "Nabo Jibon Anando",
  803: "LIC Single Premium Endowment Plan",
  805: "LIC Money Back Plan 20 Years",
  806: "LIC Bima Diamond",
  807: "LIC Young Citizen(Children Education Plan)",
  808: "LIC Pension Plan (Money Back Whole Life) ",
  809: "LIC Grow Fast (Invest Smart) Plan ",
  810: "LIC's Health Plus",
  813: "LIC'S Jibon Surokkha Term Plan",
  815: "LIC Jibon Bijoy",
  814: "LIC Jibon Swapno",
  816: "LIC Jibon Shanti",
  817: "Jibon Surrokkha Plus",
  8141: "LIC Jibon Swapno-SinglePremium",
  8151: "LIC Jibon Bijoy-SinglePremium",
};

export const modeMapping = {
  M: "Monthly",
  Q: "Quarterly",
  H: "Half Yearly",
  Y: "Yearly",
  N: "Single",
  S: "Single",
};

export const permissionMap = {
  1: "User", // List Users based on module id
  2: "User", // create Users based on module id
  3: "User", // edit Users based on module id
  4: "User", // delete Users
  5: "Role", // List Roles
  6: "Role", // create Roles
  7: "Role", // Edit Roles
  8: "Role", // Delete Roles
  9: "Permission", // List Permissions
  10: "Permission", // Create Permissions
  12: "Permission", // Edit Permissions
  // 14: "Profile", // List Profile
  // 15: "Profile", // Update Profile
  13: "Policy", // Policy list
  14: "Policy", // Create Policy
};
export const formatDate = (date) => {
  const parsedDate = new Date(date);
  return parsedDate.toISOString().split("T")[0]; // Formats as "YYYY-MM-DD"
};
// ----------------------------- policy  list data
export const policies = {
  data: {
    policies: [
      {
        id: 30,
        sap_policy_id: null,
        customer_id: 1094,
        date: "2025-03-11",
        plan: 814,
        customer: {
          id: 1094,
          first_name: "Masud",
          last_name: "Vai",
          mobile: "01920199815",
        },
        policy: {
          core_system_id: 814,
          name: "LIC Jibon Swapno",
        },
      },
      {
        id: 29,
        sap_policy_id: null,
        customer_id: 1093,
        date: "2025-03-11",
        plan: 814,
        customer: {
          id: 1093,
          first_name: "Masud",
          last_name: "Vai",
          mobile: "01910199815",
        },
        policy: {
          core_system_id: 814,
          name: "LIC Jibon Swapno",
        },
      },
      {
        id: 28,
        sap_policy_id: null,
        customer_id: 1092,
        date: "2025-03-11",
        plan: 814,
        customer: {
          id: 1092,
          first_name: "Masud",
          last_name: "Vai",
          mobile: "01900199815",
        },
        policy: {
          core_system_id: 814,
          name: "LIC Jibon Swapno",
        },
      },
      {
        id: 27,
        sap_policy_id: null,
        customer_id: 1091,
        date: "2025-03-11",
        plan: 814,
        customer: {
          id: 1091,
          first_name: "Masud",
          last_name: "Vai",
          mobile: "019901779315",
        },
        policy: {
          core_system_id: 814,
          name: "LIC Jibon Swapno",
        },
      },
      {
        id: 26,
        sap_policy_id: null,
        customer_id: 1090,
        date: "2025-03-11",
        plan: 814,
        customer: {
          id: 1090,
          first_name: "Masud",
          last_name: "Vai",
          mobile: "01990177315",
        },
        policy: {
          core_system_id: 814,
          name: "LIC Jibon Swapno",
        },
      },
      {
        id: 25,
        sap_policy_id: 5,
        customer_id: 1089,
        date: "2025-03-10",
        plan: 814,
        customer: {
          id: 1089,
          first_name: "Masud",
          last_name: "Vai",
          mobile: "01997777315",
        },
        policy: {
          core_system_id: 814,
          name: "LIC Jibon Swapno",
        },
      },
      {
        id: 24,
        sap_policy_id: null,
        customer_id: 1088,
        date: "2025-03-10",
        plan: 814,
        customer: {
          id: 1088,
          first_name: "Masud",
          last_name: "Vai",
          mobile: "01999852315",
        },
        policy: {
          core_system_id: 814,
          name: "LIC Jibon Swapno",
        },
      },
      {
        id: 23,
        sap_policy_id: null,
        customer_id: 1085,
        date: "2025-03-10",
        plan: 814,
        customer: {
          id: 1085,
          first_name: "Masud",
          last_name: "Vai",
          mobile: "01999571315",
        },
        policy: {
          core_system_id: 814,
          name: "LIC Jibon Swapno",
        },
      },
      {
        id: 12,
        sap_policy_id: null,
        customer_id: 1065,
        date: "2025-03-09",
        plan: 10,
        customer: {
          id: 1065,
          first_name: "Masud",
          last_name: "Vai",
          mobile: "01555571315",
        },
        policy: null,
      },
      {
        id: 11,
        sap_policy_id: null,
        customer_id: 1064,
        date: "2025-03-09",
        plan: 10,
        customer: {
          id: 1064,
          first_name: "Masud",
          last_name: "Vai",
          mobile: "01018571315",
        },
        policy: null,
      },
    ],
  },
  message: "Success",
  status: 1,
};
export const draftEditPolicies = {
  data: {
    "data": {
        "customer_policy_details": {
            "id": 11,
            "ref_unique_id": "LIC2025050515",
            "sap_policy_id": null,
            "user_id": 13,
            "customer_id": 1325,
            "customer_age": 28,
            "date": "2025-05-29",
            "date_of_commencement": "2025-05-29",
            "plan": 801,
            "mode": "M",
            "term": 10,
            "premium_paying_term": null,
            "premium": 724,
            "sum_assured": 100000,
            "critical_illness_rider": null,
            "term_rider_Sum_assured": null,
            "hospital_rider_sum_assured": null,
            "proposer_1_purpose_of_insurance": null,
            "questions_answers": {
                "blood": null,
                "height": null,
                "weight": null,
                "pulse_rate": null,
                "smoker_status": null,
                "policy_holder_good_health": 1,
                "policy_holder_aids_hepatitis": 0,
                "policy_holder_accident_injury": 0,
                "policy_holder_remained_absent": 0,
                "policy_holder_admitted_hospital": 0,
                "policy_holder_good_health_details": null,
                "policy_holder_medical_practitioner": 0,
                "policy_holder_used_alcoholic_others": 0,
                "policy_holder_aids_hepatitis_details": null,
                "policy_holder_accident_injury_details": null,
                "policy_holder_bodily_defect_deformity": 0,
                "policy_holder_remained_absent_details": null,
                "policy_holder_suffered_diabetes_others": 0,
                "policy_holder_admitted_hospital_details": null,
                "policy_holder_medical_practitioner_details": null,
                "policy_holder_suffering_ailments_pertaining": 0,
                "policy_holder_used_alcoholic_others_details": null,
                "policy_holder_bodily_defect_deformity_details": null,
                "policy_holder_suffered_diabetes_others_details": null,
                "policy_holder_suffering_ailments_pertaining_details": null
            },
            "accidental_coverage": "Yes",
            "ci_rider_sa": 0,
            "scb_rider_sa": 0,
            "hcb_rider_sa": 0,
            "term_rider_sa": 0,
            "insurance_rider": 2,
            "annual_income": null,
            "boc_no": null,
            "boc_date": null,
            "boc_amount": null,
            "transaction_id": null,
            "is_complete": "No",
            "online_payment": "No",
            "status": 0,
            "api_response": null,
            "api_attempt": 0,
            "documents": null,
            "created_by": 605,
            "updated_by": null,
            "deleted_by": null,
            "created_at": "2025-05-29 20:06:28",
            "updated_at": "2025-05-29 20:19:43",
            "deleted_at": null,
            "customer": {
                "id": 1325,
                "first_name": "kjhgfd",
                "last_name": "jhgfds",
                "mobile": "01234567890",
                "email": null,
                "gender": "M",
                "date_of_birth": "1997-05-02",
                "national_id": "1234567890",
                "nationality": "Bangladeshi",
                "father_name": null,
                "mother_name": null,
                "spouse_name": null,
                "parmanent_address": null,
                "present_address": null,
                "place_of_birth": null,
                "education": null,
                "occupation": null,
                "annual_income": null,
                "customer_id": null,
                "otp": null,
                "status": 1,
                "created_by": 605,
                "updated_by": null,
                "deleted_by": null,
                "created_at": "2025-05-29 20:06:28",
                "updated_at": "2025-05-29 20:06:28",
                "deleted_at": null
            },
            "nominee": {
                "id": 7,
                "customer_id": 1325,
                "customer_policy_id": 11,
                "national_id": null,
                "first_name": null,
                "last_name": null,
                "mobile": null,
                "email": null,
                "relation": null,
                "date_of_birth": null,
                "age": 0,
                "gender": "M",
                "nationality": "Bangladeshi",
                "permanent_address": null,
                "present_address": null,
                "status": 1,
                "created_by": 605,
                "updated_by": null,
                "created_at": "2025-05-29 20:06:28",
                "updated_at": "2025-05-29 20:19:43"
            },
            "appointee": null,
            "user": {
                "id": 13,
                "role_id": 4,
                "en_first_name": "Milan Kanti Das",
                "en_last_name": "",
                "bn_first_name": "",
                "bn_last_name": "",
                "login_id": "00029B003",
                "branch_code": "",
                "email": null,
                "user_type": 1,
                "reset_password": 0,
                "reference": "",
                "email_verified_at": null,
                "password": "",
                "business_name": "",
                "address": "25 Dewanji Pukur Par Andorkilla \\N, Chittagong",
                "designation": "agent",
                "joining_date": null,
                "department": "",
                "mobile": "1747395448",
                "mobile_verified_at": null,
                "nid": "",
                "remember_token": "",
                "profile_photo_path": "",
                "signature_photo_path": "",
                "locale": "",
                "status": 1,
                "created_by": 1,
                "updated_by": null,
                "deleted_by": null,
                "created_at": null,
                "updated_at": null,
                "deleted_at": null
            }
        }
    },
    "message": "Success",
    "status": 1
},
  success: true,
};

// -------------------------- role list data
export const roleData = {
  status: 1,
  message: "Success",
  data: {
    roles: {
      current_page: 1,
      data: [
        {
          id: 1,
          name: "Admin",
          guard_name: "",
          active_status: 0,
          created_at: "2025-02-05 16:36:59",
          updated_at: "2025-02-06 13:26:50",
        },
        {
          id: 3,
          name: "Salesman",
          guard_name: "",
          active_status: 1,
          created_at: "2025-02-05 17:20:51",
          updated_at: "2025-02-05 17:20:51",
        },
        {
          id: 9,
          name: "Srijon",
          guard_name: "",
          active_status: 0,
          created_at: "2025-02-05 17:47:41",
          updated_at: "2025-02-05 17:47:41",
        },
        {
          id: 10,
          name: "Delivery Man",
          guard_name: "",
          active_status: 0,
          created_at: "2025-02-06 13:21:22",
          updated_at: "2025-02-06 13:21:22",
        },
        {
          id: 11,
          name: "Assistant Manager",
          guard_name: "",
          active_status: 1,
          created_at: "2025-02-18 18:15:58",
          updated_at: "2025-02-18 18:15:58",
        },
        {
          id: 12,
          name: "Agent",
          guard_name: "",
          active_status: 1,
          created_at: "2025-03-13 17:19:13",
          updated_at: "2025-03-13 17:19:13",
        },
        {
          id: 13,
          name: "User",
          guard_name: "",
          active_status: 1,
          created_at: "2025-03-15 19:08:52",
          updated_at: "2025-03-15 19:08:52",
        },
      ],
      first_page_url:
        "https://licbangladesh.com/licadmin/api-app/get-roles?page=1",
      from: 1,
      last_page: 1,
      last_page_url:
        "https://licbangladesh.com/licadmin/api-app/get-roles?page=1",
      next_page_url: null,
      path: "https://licbangladesh.com/licadmin/api-app/get-roles",
      per_page: 50,
      prev_page_url: null,
      to: 7,
      total: 7,
    },
  },
};

// policy view page ---------------------------
export const PolicyResult = {
  data: {
    customer_policy_details: {
      id: 66,
      ref_unique_id: "K1hU4zyYEt",
      sap_policy_id: null,
      user_id: 1,
      customer_id: 1124,
      customer_age: 33,
      plan: 808,
      term: 67,
      mode: "Q",
      premium_paying_term: 20,
      date: "2025-03-25",
      date_of_commencement: "2025-03-25",
      premium: 13925,
      sum_assured: 1000000,
      critical_illness_rider: null,
      term_rider_Sum_assured: null,
      hospital_rider_sum_assured: null,
      proposer_1_purpose_of_insurance: null,
      questions_answers: {
        blood: "রক্তের তথ্য",
        width: "ওজনওজন",
        height: "উচ্চতা",
        pulse_rate: "পালস রেট",
        smoker_status: "Non smoker",
        policy_holder_good_health: 1,
        policy_holder_aids_hepatitis: 1,
        policy_holder_accident_injury: 1,
        policy_holder_remained_absent: 1,
        policy_holder_admitted_hospital: 1,
        policy_holder_good_health_details: "tyjhfgjg",
        policy_holder_medical_practitioner: 1,
        policy_holder_used_alcoholic_others: 1,
        policy_holder_aids_hepatitis_details: "gfjgfj",
        policy_holder_accident_injury_details: "dsfsdafasdf",
        policy_holder_bodily_defect_deformity: 1,
        policy_holder_remained_absent_details: "zffsdfsd",
        policy_holder_suffered_diabetes_others: 1,
        policy_holder_admitted_hospital_details: "gfjhfgjf",
        policy_holder_medical_practitioner_details: " NAAAAAAAA",
        policy_holder_used_alcoholic_others_details: "hdfh",
        policy_holder_suffering_ailments_pertaining: 1,
        policy_holder_bodily_defect_deformity_details: "sdfsdfgsdg",
        // policy_holder_suffered_diabetes_others_details
        policy_holder_suffered_diabetes_others_details: "tyhdhdf",
        policy_holder_suffering_ailments_pertaining_details: "fhfghdfh",
      },
      accidental_coverage: "No",
      is_complete: "No",
      online_payment: "No",
      status: 1,
      documents: null,
      created_by: 1,
      updated_by: null,
      deleted_by: null,
      created_at: "2025-03-25 11:30:36",
      updated_at: "2025-03-25 11:30:36",
      deleted_at: null,
      customer: {
        id: 1124,
        first_name: "Arena",
        last_name: "Phone",
        gender: "M",
        date_of_birth: "1992-03-03",
        national_id: "7354442489",
        nationality: "Bangladeshi",
        father_name: "X",
        mother_name: "Y",
        spouse_name: "Z",
        parmanent_address: null,
        present_address: "Dhaka",
        place_of_birth: "Dhaka",
        mobile: "01842069037",
        email: "hasdfg@gmail.com",
        education: "Post Graduate",
        occupation: "Private Service",
        annual_income: "Above 1000000",
        customer_id: null,
        otp: null,
        status: 1,
        created_by: 1,
        updated_by: null,
        deleted_by: null,
        created_at: "2025-03-25 11:30:35",
        updated_at: "2025-03-25 11:30:35",
        deleted_at: null,
      },
      nominee: {
        id: 146,
        customer_id: 1124,
        customer_policy_id: 66,
        first_name: "sdfsadf",
        last_name: "sdfsdfa",
        relation: "Friend",
        date_of_birth: "2020-03-09",
        age: null,
        gender: "F",
        national_id: "6544896547",
        nationality: "Bangladeshi",
        permanent_address: null,
        present_address: "adsfsadf",
        mobile: "01569845568",
        email: null,
        status: 0,
        created_by: 1,
        updated_by: null,
        created_at: "2025-03-25 11:30:36",
        updated_at: "2025-03-25 11:30:36",
      },
      appointee: {
        id: 8,
        customer_id: 1124,
        customer_policy_id: 66,
        first_name: "fghjdfjh",
        last_name: "fdhfghdh",
        relation: "Friend",
        date_of_birth: null,
        age: null,
        gender: "F",
        national_id: "1111111111",
        nationality: "Bangladeshi",
        permanent_address: null,
        present_address: "hfdh",
        mobile: "01569845568",
        email: null,
        status: 1,
        created_by: 1,
        updated_by: null,
        created_at: "2025-03-25 11:30:36",
        updated_at: "2025-03-25 11:30:36",
      },
    },
  },
};

// --------------------------- user data

export const draftPolicy = {
  data: {
    data: {
      customer_policy_details: {
        id: 266,
        ref_unique_id: "dLENfkyrtc",
        sap_policy_id: null,
        user_id: 96,
        customer_id: 1118,
        customer_age: 43,
        plan: 802,
        term: 29,
        mode: "M",
        premium_paying_term: null,
        date: "2025-04-29",
        date_of_commencement: "2025-04-29",
        premium: 394,
        sum_assured: 100000,
        critical_illness_rider: null,
        term_rider_Sum_assured: null,
        hospital_rider_sum_assured: null,
        proposer_1_purpose_of_insurance: null,
        questions_answers: {
          blood: null,
          height: null,
          pulse_rate: null,
          smoker_status: null,
          policy_holder_good_health: 0,
          policy_holder_aids_hepatitis: 0,
          policy_holder_accident_injury: 0,
          policy_holder_remained_absent: 0,
          policy_holder_admitted_hospital: 0,
          policy_holder_good_health_details: null,
          policy_holder_medical_practitioner: 0,
          policy_holder_used_alcoholic_others: 0,
          policy_holder_aids_hepatitis_details: null,
          policy_holder_accident_injury_details: null,
          policy_holder_bodily_defect_deformity: 0,
          policy_holder_remained_absent_details: null,
          policy_holder_suffered_diabetes_others: 0,
          policy_holder_admitted_hospital_details: null,
          policy_holder_medical_practitioner_details: null,
          policy_holder_suffering_ailments_pertaining: 0,
          policy_holder_used_alcoholic_others_details: null,
          policy_holder_bodily_defect_deformity_details: null,
          policy_holder_suffered_diabetes_others_details: null,
          policy_holder_suffering_ailments_pertaining_details: null,
        },
        accidental_coverage: "No",
        ci_rider_sa: 0,
        scb_rider_sa: 0,
        hcb_rider_sa: 0,
        term_rider_sa: 0,
        insurance_rider: 3,
        is_complete: "No",
        online_payment: "No",
        status: 0,
        api_response: null,
        api_attempt: 0,
        documents: null,
        created_by: 96,
        updated_by: null,
        deleted_by: null,
        created_at: "2025-04-29 12:27:32",
        updated_at: "2025-04-29 12:27:32",
        deleted_at: null,
        customer: {
          id: 1118,
          first_name: "wesadas",
          last_name: "dasd",
          gender: "M",
          date_of_birth: "1995-01-31",
          national_id: "7354442481",
          nationality: "Bangladeshi",
          father_name: "asdasd",
          mother_name: "asdasd",
          spouse_name: "asdasd",
          parmanent_address: null,
          present_address: "asdfsad",
          place_of_birth: "sadfsadf",
          mobile: "01767394491",
          email: "kjvasgdbn @gmail.com",
          education: "Post Graduate",
          occupation: "Others",
          annual_income: "Below 500000",
          customer_id: null,
          otp: 96270,
          status: 1,
          created_by: 96,
          updated_by: null,
          deleted_by: null,
          created_at: "2025-03-17 08:23:57",
          updated_at: "2025-04-24 12:29:48",
          deleted_at: null,
        },
        nominee: {
          id: 322,
          customer_id: 1118,
          customer_policy_id: 266,
          first_name: "Fahim",
          last_name: "szfgdf",
          relation: "B",
          date_of_birth: "1998-09-03",
          age: 26,
          gender: "M",
          national_id: "7354442480",
          nationality: "Bangladeshi",
          permanent_address: null,
          present_address: "aaaa",
          mobile: "01842069035",
          email: "fahim@gmail.com",
          status: 1,
          created_by: 96,
          updated_by: null,
          created_at: "2025-04-29 12:27:32",
          updated_at: "2025-04-29 12:27:32",
        },
        appointee: null,
      },
    },
    message: "Success",
    status: 1,
  },
};

export const formatToYmd = (v) => {
  if (!v) return "";
  const s = String(v).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const dmyDash = s.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
  if (dmyDash) {
    const [, d, mo, y] = dmyDash;
    return `${y}-${String(mo).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
  }
  const dmySlash = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (dmySlash) {
    const [, d, mo, y] = dmySlash;
    return `${y}-${String(mo).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
  }
  const ymdSlash = s.match(/^(\d{4})\/(\d{1,2})\/(\d{1,2})$/);
  if (ymdSlash) {
    const [, y, mo, d] = ymdSlash;
    return `${y}-${String(mo).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
  }
  return s;
};

export const mapRelationToCode = (val) => {
  if (!val) return "";
  const s = String(val).trim().toUpperCase();
  if (["H", "W", "F", "M", "B", "S", "D", "R", "O"].includes(s)) return s;
  if (s.includes("HUSBAND")) return "H";
  if (s.includes("WIFE") || s.includes("SPOUSE")) return "W";
  if (s.includes("FATHER")) return "F";
  if (s.includes("MOTHER")) return "M";
  if (s.includes("BROTHER")) return "B";
  if (s.includes("SON")) return "S";
  if (s.includes("DAUGHTER")) return "D";
  if (s.includes("CHILD")) return "S";
  if (s.includes("RELATIVE") || s.includes("SISTER")) return "R";
  return "O";
};

export const cleanMode = (rawMode) => {
  if (!rawMode) return "Y";
  const m = String(rawMode).trim().toUpperCase();
  if (["Y", "M", "H", "Q", "N", "S"].includes(m)) return m === "S" ? "N" : m;
  if (m.includes("MONTH")) return "M";
  if (m.includes("QUARTER")) return "Q";
  if (m.includes("HALF") || m.includes("SEMI")) return "H";
  if (m.includes("YEAR") || m.includes("ANNUAL")) return "Y";
  if (m.includes("SINGLE")) return "N";
  return m;
};

